import type { IClientMessage } from '@/entities/client.entity';
import { cn } from '@/lib/utils';
import { MessageSquareIcon } from 'lucide-react';
import TimeAgo from 'react-timeago';
import russianStrings from 'react-timeago/lib/language-strings/ru';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';

const formatter = buildFormatter(russianStrings);

interface ClientSmsCardProps {
	message: IClientMessage;
	onCopy: (text: string) => void;
	className?: string;
}

export default function ClientSmsCard({ message, onCopy, className }: ClientSmsCardProps) {
	return (
		<div className={cn('rounded-lg border border-border bg-card p-2.5 shadow-sm border-l-[3px] border-l-chart-2', className)}>
			<div className='flex items-start gap-2'>
				<div className='flex size-7 shrink-0 items-center justify-center rounded-lg bg-chart-2/15 text-chart-2'>
					<MessageSquareIcon size={14} />
				</div>

				<div className='min-w-0 flex-1'>
					<div className='flex items-center justify-between gap-2'>
						<button
							type='button'
							className='text-sm font-semibold text-chart-2 hover:bg-accent rounded-xs px-0.5 cursor-pointer select-none truncate'
							onClick={() => onCopy(message.sender)}
						>
							{message.sender}
						</button>
						<span className='text-xs text-muted-foreground shrink-0'>
							<TimeAgo date={message.createdAt} formatter={formatter} />
						</span>
					</div>
				</div>
			</div>

			<button
				type='button'
				className='mt-1.5 block w-full text-left rounded-2xl rounded-tl-sm bg-muted/50 px-2.5 py-2 text-sm leading-relaxed hover:bg-muted/70 cursor-pointer select-none'
				onClick={() => onCopy(message.text)}
			>
				{message.text}
			</button>
		</div>
	);
}
